import { render, staticRenderFns } from "./WJ51C.vue?vue&type=template&id=0aa42e90&scoped=true"
import script from "./WJ51C.vue?vue&type=script&lang=js"
export * from "./WJ51C.vue?vue&type=script&lang=js"
import style0 from "./WJ51C.vue?vue&type=style&index=0&id=0aa42e90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa42e90",
  null
  
)

export default component.exports